import { createContext } from 'react';

type AuthContextProps = {
  handleLogout: () => void;
};

export default createContext<AuthContextProps>({
  handleLogout: () => {},
});
